import {useParams} from "react-router";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCrownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {IRankingAnnualParams} from "@pg-mono/rp-routes";

interface IRankingListBanner {
    handleGetMoreInfoClick: () => void;
    name_declension_where?: string;
}

export const RankingListBanner = (props: IRankingListBanner) => {
    const params = useParams<IRankingAnnualParams>();

    return (
        <div className={rankingListBannerWrapper}>
            <BrandCrownIcon className={icon} size="8" wrapperColor="var(--colors-primary)" wrapperSize="8" />

            <div className={copy}>
                <Text className={copyTitle} as="h1" variant="headline_3" fontFamily="secondary" mb={1}>
                    Ranking najlepszych inwestycji {props.name_declension_where} {params.year}
                </Text>

                <Button variant="filled_primary" size="x-small" onClick={props.handleGetMoreInfoClick}>
                    Dowiedz się więcej o rankingu
                </Button>
            </div>
        </div>
    );
};

const rankingListBannerWrapper = css({
    backgroundColor: "var(--colors-success)",
    borderRadius: 2,
    p: 3,
    mt: 3,
    mb: 4,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    sm: {
        py: 3,
        px: 6,
        flexDirection: "row"
    }
});

const copy = css({
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    sm: {
        alignItems: "flex-start"
    }
});

const copyTitle = css({
    textAlign: "center",
    md: {
        textAlign: "left"
    }
});

const icon = css({
    mb: 3,
    sm: {
        mr: 4,
        mb: 0
    }
});
import {useParams} from "react-router";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandCrownIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {IRankingAnnualParams} from "@pg-mono/rp-routes";

interface IRankingListBanner {
    handleGetMoreInfoClick: () => void;
    name_declension_where?: string;
}

export const RankingListBanner = (props: IRankingListBanner) => {
    const params = useParams<IRankingAnnualParams>();

    return (
        <div className={rankingListBannerWrapper}>
            <BrandCrownIcon className={icon} size="8" wrapperColor="var(--colors-primary)" wrapperSize="8" />

            <div className={copy}>
                <Text className={copyTitle} as="h1" variant="headline_3" fontFamily="secondary" mb={1}>
                    Ranking najlepszych inwestycji {props.name_declension_where} {params.year}
                </Text>

                <Button variant="filled_primary" size="x-small" onClick={props.handleGetMoreInfoClick}>
                    Dowiedz się więcej o rankingu
                </Button>
            </div>
        </div>
    );
};

const rankingListBannerWrapper = css({
    backgroundColor: "var(--colors-success)",
    borderRadius: 2,
    p: 3,
    mt: 3,
    mb: 4,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    sm: {
        py: 3,
        px: 6,
        flexDirection: "row"
    }
});

const copy = css({
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    sm: {
        alignItems: "flex-start"
    }
});

const copyTitle = css({
    textAlign: "center",
    md: {
        textAlign: "left"
    }
});

const icon = css({
    mb: 3,
    sm: {
        mr: 4,
        mb: 0
    }
});
